import { render, staticRenderFns } from "./resultlist.vue?vue&type=template&id=dd808f60&scoped=true&"
import script from "./resultlist.vue?vue&type=script&lang=js&"
export * from "./resultlist.vue?vue&type=script&lang=js&"
import style0 from "./resultlist.vue?vue&type=style&index=0&id=dd808f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd808f60",
  null
  
)

export default component.exports